import { render, staticRenderFns } from "./signUpPage.vue?vue&type=template&id=1f3ae63d&scoped=true&"
import script from "./signUpPage.vue?vue&type=script&lang=js&"
export * from "./signUpPage.vue?vue&type=script&lang=js&"
import style0 from "./signUpPage.vue?vue&type=style&index=0&id=1f3ae63d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ae63d",
  null
  
)

export default component.exports